module.exports = __webpack_public_path__ + "12e7108d9caeb7b9bc5c0a7329407b55.svg";